export const isIdleBannerDisabled = (): boolean => {
  if (typeof window === 'undefined') return false
  return process.env.NEXT_PUBLIC_DISABLE_IDLE_FEATURE === 'true'
}
